const ONETRUST_CONSENT_MANAGER_PLUGIN = 'OneTrustConsentManagerPlugin';

export { ONETRUST_CONSENT_MANAGER_PLUGIN };
